//-------------
//  Simple Button Guard - Prevents rapid button clicks
//-------------

/**
 * Simple button click protection utility
 * @param {Function} handler - Original click handler
 * @param {number} cooldownMs - Cooldown time in milliseconds
 * @returns {Function} Protected click handler
 */
export function guardButton(handler, cooldownMs = 300) {
  let lastClickTime = 0;

  return function (...args) {
    const now = Date.now();
    if (now - lastClickTime < cooldownMs) {
      return undefined; // Ignore rapid clicks
    }

    lastClickTime = now;
    return handler.apply(this, args);
  };
}

/**
 * Guard for async operations (prevents multiple concurrent executions)
 * @param {Function} asyncHandler - Async click handler
 * @returns {Function} Protected async handler
 */
export function guardAsyncButton(asyncHandler) {
  let isExecuting = false;

  return async function (...args) {
    if (isExecuting) {
      return undefined; // Ignore clicks while executing
    }

    isExecuting = true;
    try {
      return await asyncHandler.apply(this, args);
    } finally {
      isExecuting = false;
    }
  };
}
